import React, { useState } from 'react'
import useAssociatedBehaviors, {
  AssociatedBehaviorsProvider,
} from './AssociatedBehaviorsProvider'
import { Textarea } from '../../../lib/ui/textarea'
import { Label } from '../../../lib/ui/label'
import useTranslation, {
  TranslationProvider,
} from '../../shared/TranslationProvider'
import translations from '../locales.json'

const AssociatedBehaviors = ({ locale, ...props }) => {
  return (
    <TranslationProvider
      locale={locale}
      translations={translations}
      scope={'javascript.components.ValuesAssessment.AssociatedBehaviors'}
    >
      <AssociatedBehaviorsProvider {...props}>
        <AssociatedBehaviorsInner />
      </AssociatedBehaviorsProvider>
    </TranslationProvider>
  )
}

export default AssociatedBehaviors

const AssociatedBehaviorsInner = () => {
  const { selectedValues } = useAssociatedBehaviors()
  return (
    <div className="flex flex-col gap-6">
      {selectedValues.map((val, idx) => (
        <ValueInputTile key={`val-input-tile-${idx}`} value={val} />
      ))}
    </div>
  )
}

const ValueInputTile = ({ value }) => {
  const { t } = useTranslation('ValueInputTile')
  const { state, dispatch, updateDocument, getValueName } =
    useAssociatedBehaviors()
  const valueName = getValueName(value)
  const [inputValue, setInputValue] = useState(state.behaviors[value] || '')
  const [exampleValue, setExampleValue] = useState(state.examples[value] || '')

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
    dispatch({
      type: 'UPDATE_BEHAVIOR',
      payload: { name: value, content: e.target.value },
    })
  }

  const handleExampleChange = (e) => {
    setExampleValue(e.target.value)
    dispatch({
      type: 'UPDATE_EXAMPLE',
      payload: { name: value, content: e.target.value },
    })
  }

  return (
    <div>
      <div className="mb-4 font-bold">
        {t('value')} {valueName[0].toUpperCase() + valueName.slice(1)}
      </div>
      <Label className="font-roboto" for={`${valueName}-behavior`}>
        {t('behaviors_that_exhibit_value')}
      </Label>
      <Textarea
        value={inputValue}
        onChange={handleInputChange}
        onBlur={updateDocument}
        className="mb-4 font-roboto"
        id={`${valueName}-behavior`}
        name={`${valueName}-behavior`}
      />
      <Label className="font-roboto" for={`${valueName}-example`}>
        {t('workplace_value_in_action')}
      </Label>
      <Textarea
        value={exampleValue}
        onChange={handleExampleChange}
        onBlur={updateDocument}
        className="mb-4 font-roboto"
        id={`${valueName}-example`}
        name={`${valueName}-example`}
      />
    </div>
  )
}
